import { useContext, createContext } from 'react';

export type UploadResult = { filename: string; fileDrn: string };

type DukeTiptapEditorContextType = {
  uploadFn: ((file: File) => Promise<UploadResult>) | undefined;
};

export const DukeTiptapEditorContext = createContext<DukeTiptapEditorContextType | undefined>(
  undefined,
);

export function useDukeTiptapEditor() {
  const context = useContext(DukeTiptapEditorContext);
  if (context === undefined) {
    throw new Error('useDukeTiptapEditor must be used within a DukeTiptapEditorProvider');
  }
  return context;
}
